/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import Card from './Card'

const GridView = ({subscriptions, setSubscriptions,limit, page,setLoading, benefits, pricing, selectedCurrency}) => {
  const dispatch = useDispatch()
  dispatch(setTitle('Subscription'))

  return (
    <>
        {subscriptions?.records &&
          subscriptions?.records?.map((value, index) => {
            return (
              <div className='col-lg-4 col-md-6' key={index}>
                <Card
                  sub={value}
                  setLoading={setLoading}
                  setSubscriptions={setSubscriptions}
                  benefits={benefits}
                  pricing={pricing}
                  currency={selectedCurrency}
                  limit={limit}
                  offset={(page - 1) * limit}
                />
              </div>
            )
          })}
    </>
  )
}
export default GridView